<header>
    <div class="header-prefix">
        <ng-content select="[prefix]" />
    </div>

    <div class="header-title inline-flex flex-col">
        <h1
            qpxHeading
            variant="lg"
            [id]="titleId()"
            [class.interactive]="projectedLabel()?.interactive()"
        >
            @if (projectedLabel()) {
                <ng-content select="[qpxHeaderLabel]" />
            } @else {
                <span>{{ heading() }}</span>
            }
        </h1>

        <div class="subtitle">
            <ng-content select="[subtitle]" />
        </div>
    </div>

    <ng-content select="[suffix]" />
</header>

<section class="header-actions" aria-label="Primary actions">
    <ng-content select="[actions]" />
</section>
